// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1_PgO","cls2":"CreateSocialItem-cls2_lmn CreateSocialItem-cls1_PgO"};